$ = require('jquery')

module.exports =
	init: (payload) ->

		isTouch = $('html').hasClass('touch')
		$window = $(window)
		$document = $(document)

		$('.header__menu').each(->
			$holder = $(this)
			$title = $holder.find('> .header__menu__title')
			$main = $holder.find('> .header__menu-main')
			$toggle = $holder.find('> .header__menu-toggle')

			# mobile menu
			$toggle.html($main.html())

			$items = $main.find('> ul > li')
			$mobileItems = $toggle.find('> ul > li')
			titleWidth = 100
			itemsWidths = null
			itemsWidthsSums = null

			prepare = ->
				itemsWidths = $items.map(() -> return $(this).outerWidth(true)).get()
				itemsWidthsSums = itemsWidths.reduce((acc, cur, index, arr) ->
					sum = if index > 0 then acc[index - 1] else 0
					acc.push(sum + cur)
					return acc
				, [])

				return

			getIndexGreaterThen = (val, arr) ->
				return arr.filter((cur) ->
					return (cur < val)
				).length

			calc = ->
				if $(window).width() < 700
					index = 0
					isToggleMenu = true
				else
					currentWidth = $main.outerWidth()
					index = getIndexGreaterThen(currentWidth, itemsWidthsSums)
					isToggleMenu = (index < $items.length)

					if isToggleMenu
						index = getIndexGreaterThen(currentWidth - titleWidth, itemsWidthsSums)

				$holder.toggleClass('has-toggle', isToggleMenu)
				unless isToggleMenu
					$holder.removeClass('is-open')

				$items.slice(0, index).css('display', '')
				$items.slice(index).css('display', 'none')

				$mobileItems.slice(0, index).css('display', 'none')
				$mobileItems.slice(index).css('display', '')

			prepare()
			calc()

			$window
				.on('load', ->
					prepare()
					calc()
				)
				.on('resize', ->
					calc()
				)

			$holder.css('visibility', 'visible')
		)



/** WEBPACK FOOTER **
 ** ./src/js/components/headerMenu.coffee
 **/